import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const Home = () => {
  const [loaded, setLoaded] = useState(false);

  const imageUrl =
    "https://images.unsplash.com/photo-1550989460-0adf9ea622e2?auto=format&fit=crop&w=1600&q=80";

  useEffect(() => {
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
      setLoaded(true);
    };
  }, []);

  return (
    <div className={`home ${loaded ? "loaded" : ""}`}>
      <div
        className="bg-image"
        style={{ backgroundImage: `url(${imageUrl})` }}
      ></div>

      <div className="overlay">
        <div className="hero-text">
          <h1>
  Welcome to <span>Pace Service Affairs Limited</span>
</h1>
          <h2></h2>
          <p>
            Your trusted UK e-commerce platform for quality groceries
            and fast delivery.
          </p>

          <Link to="/products" className="shop-btn">
            Shop Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;